//libraries
import Vue from 'vue'
import axios from 'axios'

let resource = 'model'
let resource_name = 'modelo'
let resource_name_plural = 'modelos'

let state = {
  models: [],
  updatingModels: false,
  lastModelsUpdate: null
}

state[resource] = []

//functions receive state
let getters = {

}

//functions receive context and params
let actions = {
  async all ({ commit, state }, params) {
    try {
      if (state.updatingModels || !canUpdateModels(state.lastModelsUpdate)) {
        if (params.callback) params.callback({
          success: true
        })

        return
      } else {
        commit('setLastModelsUpdate')
      }

      commit('toggleUpdatingModels', true)
      let res = await Vue.request_sam.get(`account/${params.account_id}/${resource}s`, {params: params.params || {}})

      commit('toggleUpdatingModels')
      if(res.data.success) {
        commit('setItems', res.data.resource)
        if(params.callback)
          params.callback(res.data)
      } else {
        if(params.callback)
          params.callback({error: `Error obteniendo ${resource_name_plural}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name_plural}.`})
      console.error(e)
    }
  },
  async get ({ commit }, params) {
    try {
      let res = await Vue.request_sam.get(`account/${params.account_id}/${resource}s/${params.model_id}`, {params: params.params || {}})
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo ${resource_name}.`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo ${resource_name}.`})
      console.error(e)
    }
  },
}

//functions receive state
let mutations = {
  setItems (state, items) {
    state.models = items
  },
  toggleUpdatingModels (state, updating) {
    state.updatingModels = updating != undefined ? updating : false
  },
  setLastModelsUpdate (state) {
    state.lastModelsUpdate = Vue.prototype.$moment()
  }
}

var canUpdateModels = function (lastModelsUpdate) {
  if (lastModelsUpdate) {
    let ellapsedMinutes = Vue.prototype.$moment().diff(lastModelsUpdate, 'minutes')
    return ellapsedMinutes >= 1
  }

  return true
}

export default {
  state,
  mutations,
  actions,
  getters
}
